import type { NavLink } from "@rakazo/contracts";
import { AudioLines, Link2, Phone } from "lucide-react";

export function accountMenuLinkIcon(link: Pick<NavLink, "id" | "label">) {
  const names = [link.id.toLowerCase(), link.label.toLowerCase()];
  if (names.some((name) => /\bomi/i.test(name))) return AudioLines;
  if (names.some((name) => /\bgreg/i.test(name))) return Phone;
  return Link2;
}
